import { render, staticRenderFns } from "./DialogListDepartments.vue?vue&type=template&id=2bafdbc6&scoped=true&"
import script from "./DialogListDepartments.vue?vue&type=script&lang=js&"
export * from "./DialogListDepartments.vue?vue&type=script&lang=js&"
import style0 from "./DialogListDepartments.vue?vue&type=style&index=0&id=2bafdbc6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bafdbc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VDialog,VIcon,VSkeletonLoader,VTooltip})
